import { Directive, HostListener, Input } from '@angular/core';
import { TypeaheadDirective } from 'ngx-bootstrap/typeahead';
import { isIE } from '@schoolbelle/common/functions';
// const isIE = navigator.userAgent.indexOf('MSIE')!==-1 || navigator.appVersion.indexOf('Trident/') > -1;
const is_ie = isIE();


@Directive({selector: '[typeaheadIeFix]', exportAs: 'bs-typeahead'})
export class TypeaheadIeFixDirective extends TypeaheadDirective {
  private ie_init:boolean = false;
  @Input('typeaheadIeFix') typeahead: any;

  @HostListener('blur')
  onBlur(): void {
    if (!this._matches) this._matches = [];
    super.onBlur();
  }
  /**
   * when ngModel or formControl is init'ed, it seems to update input value triggering an 'input' event in IE.
   * that 'input' event then causes typeahead directive to focus on the bound input and even open its suggestion list if possible. 
   * listening to 'change' event intead of 'input' event
   * you can get around this behavior in IE.
   */
  onInput (e) {
    if (is_ie && !this.ie_init) {
      this.ie_init = true;
      return;
    }
    super.onInput(e);
  }
}
